module.exports = __webpack_public_path__ + "img/1071003612.ef724706.jpg";